import { validationHelper } from '../helpers'

export const integerOnlyField = (minValue = undefined, defaultValue = undefined) => (value, previousValue) => {
    return validationHelper.integerOnly(value, minValue, defaultValue)
}

export const decimalOnlyField = (minValue = undefined, maxValue = undefined) => (value, previousValue) => {
    return validationHelper.decimalOnly(value, minValue, maxValue)
}

export const numberOnlyField = (maxValue) => (value, previousValue) => {
    return validationHelper.numberOnly(value, maxValue)
}

export const letterOnlyField = () => (value, previousValue) => {
    return validationHelper.letterOnly(value)
}

export const noSpecialsField = () => (value, previousValue) => {
    return validationHelper.noSpecials(value)
}

export const emailOnlyField = () => (value, previousValue) => {
    return validationHelper.emailOnly(value)
}

export const dateOnlyField = () => (value, previousValue) => {
    return validationHelper.dateOnly(value)
}

export const selectedItem = () => (value) => {
    return validationHelper.isDefaultSelected(value)
}


// WEBPACK FOOTER //
// ./src/common/helpers/normalize.js